export default {
    home: '/',
    login: '/login/phone',
    verifyCode: '/login/code',
    register: '/login/register',
    scan: '/start',
    scanner:'/scanner',
    vehicleId:'/vehicle/id',
    Credit:'/credit',
    Gift:'/gift',
    Setting:'/setting',
    subscription: '/subscription',
    order: '/order',
    typingBarcode: '/start/typing',
    qrcodeCameraAccess: '/start/camera-access',
    qrcodeScanning: '/start/qrcode',
    purchaseCallback: '/purchase-callback',
    trips: '/trips',
    trip: '/trip',
    rideGuide: '/guides/ride',
    intro: '/intro',
    payments: '/payments',
    rideCanceled: "/guides/cancel"
}
